import { toNumber } from '../../../utils/numberUtils.js'
import { toYearMonth } from '../../../utils/dateUtils.js'

function isAutonomoRow(r) {
  const reg = String(r?.regimenContributivo || '').toUpperCase()
  if (reg === 'AUTONOMO') return true
  if (reg === 'DEPENDENCIA') return false
  const tag = String(r?.tipoActividad || r?.tipo || r?.tipoRaw || '').toLowerCase()
  return tag.includes('autonom') || tag.includes('mono')
}

function sumUpdated(rows = []) {
  return (Array.isArray(rows) ? rows : []).reduce(
    (acc, r) => acc + toNumber(r.montoActualizadoPromedio || r.montoActualizado || r.montoBasePromedio || r.montoSujetoAAporte),
    0,
  )
}

function diasComputablesRow(r = {}) {
  const candidates = [r?.diasComputables, r?.diasOrigen, r?.dias]
  for (const candidate of candidates) {
    const n = Number(candidate)
    if (Number.isFinite(n) && Number.isInteger(n) && n > 0) return n
  }
  return 30
}

function computePcPap(rowsForAvg = [], corteJul94 = 199407, divisorPolicy = 'legal_120', allRows = null) {
  const sample = Array.isArray(rowsForAvg) ? rowsForAvg : []
  // ═══════════════════════════════════════════════════════════════
  // Gap #2: usar TODAS las filas para cómputo de años, no solo
  // las últimas 120. El slice(-120) previo solo afecta al promedio.
  // ═══════════════════════════════════════════════════════════════
  const yearSet = Array.isArray(allRows) ? allRows : sample
  let diasPre94 = 0
  let diasPost94 = 0
  yearSet.forEach((r) => {
    const ym = toYearMonth(r.periodoKey || r.periodo || r.periodoISO)
    if (!ym) return
    const dias = diasComputablesRow(r)
    if (ym < corteJul94) diasPre94 += dias
    else diasPost94 += dias
  })
  const aniosPre94 = diasPre94 / 365
  const aniosPost94 = diasPost94 / 365
  const divisorLegal = 120
  const mesesConAportes = Math.max(1, sample.length)
  const divisorEfectivo = mesesConAportes < divisorLegal ? mesesConAportes : divisorLegal
  const divisor = divisorPolicy === 'muestra_efectiva' ? mesesConAportes : divisorEfectivo
  const promedio = sumUpdated(sample) / Math.max(1, divisor)
  return {
    promedio: Number(promedio.toFixed(2)),
    meses: sample.length,
    aniosPre94: Number(aniosPre94.toFixed(4)),
    aniosPost94: Number(aniosPost94.toFixed(4)),
    pc: Number((promedio * 0.015 * aniosPre94).toFixed(2)),
    pap: Number((promedio * 0.015 * aniosPost94).toFixed(2)),
  }
}

export function calcularHaberMixto(rows = [], options = {}) {
  const valid = Array.isArray(rows) ? rows.filter((r) => !r.invalidoPorCese) : []
  const dependenciaRows = valid.filter((r) => !isAutonomoRow(r))
  const autonomoRows = valid.filter((r) => isAutonomoRow(r))

  const depAll = dependenciaRows
    .slice()
    .sort((a, b) => String(a.periodoKey || '').localeCompare(String(b.periodoKey || '')))
  const dep120 = depAll.slice(-120)
  const autAll = autonomoRows
    .slice()
    .sort((a, b) => String(a.periodoKey || '').localeCompare(String(b.periodoKey || '')))

  const corteJul94 = Number(options?.corteJul94 || 199407)
  const divisorPolicy = String(options?.divisorPolicy || 'legal_120')

  const dep = computePcPap(dep120, corteJul94, divisorPolicy, depAll)
  const aut = computePcPap(autAll, corteJul94, 'muestra_efectiva')

  return {
    dependencia: dep,
    autonomos: aut,
    pcTotal: Number((dep.pc + aut.pc).toFixed(2)),
    papTotal: Number((dep.pap + aut.pap).toFixed(2)),
    mixedDetected: dep.meses > 0 && aut.meses > 0,
  }
}
